import React from 'react';
import { useDispatch } from 'react-redux';

import { openUploadedFile, downloadUploadedFileEquipement } from 'store/forms/actions';
import { ReactComponent as FileExcel } from 'assets/icons/excel_icon.gov.svg';
import { ReactComponent as FileWord } from 'assets/icons/word_icon.gov.svg';
import { ReactComponent as FilePdf } from 'assets/icons/pdf_icon.gov.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download_blue.svg';
import { getFullIsoDate } from 'utils';
import { isNil } from 'lodash';
import { useSelector } from 'react-redux';

const DownloadEquipement = ({ description, file }) => {


 console.log({description});
 console.log("in Download file has",file);

 const isEmptyList = (file) =>
  !Array.isArray(file) || file.length === 0 || file.every(v => v == null);

  const certifications = useSelector(state => state.forms.documents.certification);
  const dispatch = useDispatch();
  const renderIcon = type => {
    switch (type) {
      case 'pdf':
        return <FilePdf />;
      case 'excel':
        return <FileExcel />;
      default:
        return <FileWord />;
    }
  };

if(!isEmptyList(file)){
 return Array.isArray(file)
  ? file.map((f, index) => (
      <div key={index} className="download-file mb-2">
        {index === 0 && (
          <div className="download-file__title">{description}</div>
        )}
        <div className="d-flex justify-content-left mr-2">
          <div className="d-flex align-items flex-grow-1">
            {renderIcon(f?.simpleType)}
            <div className="download-file__details">
              <div className="filename">{f?.name}</div>
              <div className="filesize">
                {Math.round(f?.contentSize / 1000)} KB
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center" style={{ marginLeft:'16.5rem' }}>
            <div
              type="button"
              className="btn btn-link p-0 d-flex align-items-center"
              id='download-button'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(downloadUploadedFileEquipement(f));
              }}
            >
              <span className="download-label ms-1"><DownloadIcon className="download-file__icon" />  Download</span>
            </div>
          </div>
        </div>
      </div>
    ))
  : null;
} else {
  return null;
}

};

export default DownloadEquipement;
